export default {
  include(state) {
    return state.include;
  },
  axiosPing(state) {
    return state.axiosPing;
  },
  loading(state) {
    return state.loading;
  },
  backFlag(state) {
    return state.backFlag;
  },
  language(state) {
    return state.language;
  },
  token(state) {
    return state.token;
  },
  userInfo(state) {
    return state.userInfo;
  },
  platformInfo(state) {
    return state.platformInfo;
  },
  shopCartData(state) {
    return state.shopCartData;
  },
  againOrder(state) {
    return state.againOrder;
  },
  location(state) {
    return state.location;
  }
};
